export const isServerSide = () => typeof window === "undefined";
export const isClientSide = () => !isServerSide();
export const isRunningOnLocalhost = (host: string | undefined): boolean => {
    return host === "localhost:3000";
};

export const isRunningOnVercel = (): boolean => {
    return process.env.VERCEL_URL !== undefined;
};

export const isNewInfrastructure = (): boolean => {
    return process.env.INFRA_VERSION !== undefined;
}